import { useMutation } from '@apollo/client';
import { UpdateInsightsDashboardDocument, } from './UpdateInsightsDashboard.gql';
export function useUpdateDashboard() {
    const [mutate, state] = useMutation(UpdateInsightsDashboardDocument);
    const handler = (id, input) => mutate({
        variables: { id, input },
    });
    return [handler, state];
}
